import ApproximationsManagement from "../approximationsManagement";

export const approximationsManagementRouter = [
    {
        path:"/view/approximationsManagement/approximationsManagement",//选题管理
        component:ApproximationsManagement
    },
]